import { FunctionComponent, useState } from 'react';
import { withStyles, Box, Accordion } from 'vopay';
import { useTranslation } from 'react-i18next';
import { useToken } from '../../../../providers/Token.provider';
import { useBank } from '../../../../providers/Bank.provider';
import ConnectionTypeContainer from './ConnectionType';
import AccountTypeContainer from './AccountType';
import styles from './BankTypeContainer.module.scss';

const cn = withStyles(styles);

type BankTypeContainerProps = {
  hasNoOnlineOption: boolean;
};

type FC = FunctionComponent<BankTypeContainerProps>;

const BankTypeContainer: FC = (props: BankTypeContainerProps) => {
  const { hasNoOnlineOption } = props;
  const { token } = useToken();
  const { BankingType, AccountType } = useBank();
  const { t } = useTranslation('translations', { keyPrefix: 'BankConnection' });
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  const chooseType = () => (
    <>
      {!isAccordionOpen && (BankingType !== undefined || AccountType !== undefined) ? (
        <Box flx="col" gapSize="4px" height="auto" pt="sm">
          {AccountType && (
            <div className={cn('selectedType')}>
              <span>{t('accountType')} :</span>
              <span className={cn('type')}>{AccountType}</span>
            </div>
          )}
          {token?.AccountSelectionMethod === 'any' && BankingType && (
            <div className={cn('selectedType')}>
              <span>{t('connectionType')}:</span>
              <span className={cn('type')}>{BankingType}</span>
            </div>
          )}
        </Box>
      ) : null}
    </>
  );

  const isConnectionTypeKnown = token?.AccountSelectionMethod !== 'any';
  const isAccountTypeKnown = token?.AccountHolderType !== '';

  const title =
    !isConnectionTypeKnown && !isAccountTypeKnown
      ? t('chooseTypeTitle')
      : !isConnectionTypeKnown
        ? t('chooseConnectionTypeTitle')
        : !isAccountTypeKnown
          ? t('chooseAccountTypeTitle')
          : '';

  return (
    <Accordion
      title={`2.${title}`}
      iconColor={token?.DarkMode ? 'primary-light' : 'primary-dark'}
      iconSize="xsm"
      variant="box"
      titlePadding="0px"
      open={isAccordionOpen}
      onClick={() => {
        setIsAccordionOpen(!isAccordionOpen);
      }}
      subBody={chooseType()}
      body={
        <div className={cn('typeContainer', (isConnectionTypeKnown || isAccountTypeKnown) && 'noBorder')}>
          {token?.AccountHolderType === '' && <AccountTypeContainer hasNoOnlineOption={hasNoOnlineOption} />}

          {!hasNoOnlineOption && token?.AccountSelectionMethod === 'any' && (
            <ConnectionTypeContainer hasNoOnlineOption={hasNoOnlineOption} />
          )}
        </div>
      }
    />
  );
};

export default BankTypeContainer;
